import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useLang } from "../context/LangContext";
import { formatPrice } from "../lib/api";

export const ProductCard = ({ product, index = 0 }) => {
  const { lang, t } = useLang();
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-50px" }}
      transition={{ duration: 0.6, delay: (index % 4) * 0.08, ease: [0.22, 1, 0.36, 1] }}
    >
      <Link to={`/producto/${product.id}`} data-testid={`product-card-${product.id}`} className="group block">
        <div className="overflow-hidden bg-canvas-soft aspect-[4/5] mb-4 relative">
          <img
            src={product.images?.[0]}
            alt={product[`name_${lang}`]}
            className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
          />
          {!product.in_stock && (
            <span className="absolute top-3 left-3 bg-ink/80 text-canvas text-[10px] uppercase tracking-wider px-3 py-1">
              {t("out_of_stock")}
            </span>
          )}
        </div>
        <h3 className="font-heading text-xl text-ink leading-tight">{product[`name_${lang}`]}</h3>
        <p className="text-brand-primary text-sm mt-1">{formatPrice(product.price)}</p>
      </Link>
    </motion.div>
  );
};
